import React from 'react';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import classNames from 'classnames';
import { Button, Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import './FileInputStyles.scss';
import { loadFileByUrl } from '../../../modules/System/actions';
import { responseLogWithNotification, sizeFormatter } from '../../../utils/utils';
import { renderExtIcon } from '../../../utils/formatters';
import Tooltip from '../../base/Tooltip/Tooltip';
import PreviewFile from '../../../modules/Application/components/PreviewFile';

export default function FileView(props) {
  const dispatch = useDispatch();
  const {
    files = [],
    deletedFileList = [],
    setDeletedFileList = () => {},
    isDeleted = false,
    readOnly = false,
    withoutMime = false,
    withoutHr = false,
    onlyAdditionalFile = false,
  } = props;

  const [file, setFile] = React.useState(null);
  const filesByCollection = files.reduce((acc, file) => {
    if (onlyAdditionalFile && file.collection_name !== 'additional_file') {
      return acc;
    }
    const index = acc.findIndex(c => file.collection_name === c.collection_name);
    if (index >= 0) {
      acc[index].files.push(file);
    } else {
      acc.push({
        collection_name: file.collection_name,
        collection_name_label: file.collection_name_label,
        files: [file],
      });
    }
    return acc;
  }, []);

  const downloadFile = file => {
    dispatch(loadFileByUrl(file.url))
      .then(data => {
        if (data) {
          fileDownload(data, file.file_name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const viewFile = file => {
    dispatch(loadFileByUrl(file.url))
      .then(data => {
        if (data) {
          setFile(URL.createObjectURL(data));
        }
      })
      .catch(responseLogWithNotification);
  };

  const renderFile = (file, key) => {
    const fileMime = file.mime_type || '';
    return (
      <div key={(file.name || '') + key} className="file-item">
        <div className={classNames('file-name-block', { isDeleted: deletedFileList.includes(file) })}>
          { !withoutMime ? renderExtIcon(fileMime) : null }
          <div className="file-name"><Tooltip content={file.name || ''} /></div>
          <div className="file-size">({sizeFormatter(file.size)})</div>
        </div>
        <div className="file-buttons">
          {!readOnly
            ? (
              <>
                <Button variant="secondary" onClick={() => viewFile(file)}>
                  <Icons
                    customIcon
                    icon="eye-fill"
                    className="notification-icon"
                  />
                </Button>
                <Button variant="secondary" onClick={() => downloadFile(file)}>
                  <Icons
                    customIcon
                    icon="download-2"
                    className="notification-icon"
                  />
                </Button>
              </>
            )
            : (
              <Button variant="secondary" onClick={() => downloadFile(file)}>
                <Icons
                  customIcon
                  icon="download-2"
                  className="notification-icon"
                />
              </Button>
            )}
          { isDeleted ? (
            <Button
              variant="secondary"
              onClick={() => (deletedFileList.includes(file) ? setDeletedFileList(deletedFileList.filter(e => e.id !== file.id)) : setDeletedFileList([...deletedFileList, file]))}
            >
              <Icons
                customIcon
                icon={deletedFileList.includes(file) ? 'restore' : 'close'}
                className="notification-icon"
              />
            </Button>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <>
      { filesByCollection.length && !withoutHr ? <div className="hr-row" /> : null }
      { filesByCollection.map(c => (
        <>
          { !withoutHr ? <div className="f4 mb-3">{c.collection_name_label}</div> : null }
          {c.files.map(renderFile)}
        </>
      ))}
      { file ? <PreviewFile file={file} handleClose={() => setFile(null)} /> : null }
    </>
  );
}
